import React from 'react';

function Experience(){
 return(
  <>
   <FirstSection />
   <SecondSection />
   {/* <ThirdSection /> */}
  </>

 )
}

const FirstSection = () =>{
 return (
  <div className='fontBody container' style={{paddingTop: "15vh", paddingBottom: "3vh", backgroundColor: "#429E9F"}}>
    <h2>My Experiences</h2>
  </div>
 )
}

const SecondSection = () =>{
 return (
  <div className='fontBody middle-center' style={{backgroundColor: "#A5C5C3"}} >
    {/* <h2 style={{marginBottom: '3vh', marginTop:'3vh'}}>My Projects</h2> */}

    <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', width:"80vw", marginBottom:"5vh", marginTop:"5vh"}}>
      <h2>AI Product Manager & ML Engineer</h2>
      <h3>xDRAFT Startup Initiative</h3>
      <p>(May 2022 - present)</p>
      <ul style={{paddingLeft: "2em"}}>
        <li>Created an AI-based email topic detector using NLP models, Google APIs and Flask that allows users to organize high quantity emails into subgroups, overseeing 3 data scientists and 2 SWEs</li>
        <li>Diagnosed and resolved data processing and data labeling challenges to improve the classification model accuracy by 30%</li>
        <li>Settled the B2B model for the company and defined the scope of the MVP after market research and competitor analysis</li>
        {/* <li><b>Tech Stack:</b> Python, Pandas, Flask, NLP, HuggingFace DistilBERT</li> */}
          {/* <li>Developed an MVP email & messages organization toolkit by implementing SOTA multi-label classification models using sentence transformers and DistilBERT, and achieved accuracy over 90 with f1 over 80 on customized email datasets.</li>
          <li>Preprocessed and engineered data into required schema for time extraction task using Pandas and Python.</li> */}
      </ul>
    </div>

    <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', width:"80vw", marginBottom:"5vh"}}>
      <h2>Project Manager & Researcher</h2>
      <h3>UNC-CH MURGe-Lab (UNC NLP Group)</h3>
      <p>(Aug 2021 - present)</p>
      <ul style={{paddingLeft: "2em"}}>
          <li>Developed the first AI-based, personalized Student Evaluations of Teaching (SET) reports system in a real university setting to help instructors interpret SET results more efficiently and with less bias</li>
          <li>Incorporated AI modules using sentiment analysis, topic modeling, and extractive summarization, achieved SOTA model accuracies and over 88% user satisfaction ratings</li>
          <li>Identified potential bias and data privacy issues and created debiased algorithms to reduce bias by 40%</li>
          <li>Designed and built the front-end and back-end of the <a href="https://github.com/evahuyn/SETSum">web app</a>, which will be used by over 13k instructors at the university</li>
          <li>Demoed the system at NAACL (A Top-tier NLP Conference) and transformed research outcomes to a concrete product</li>
      </ul>
    </div>

    <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', width:"80vw", marginBottom:"5vh"}}>
      <h2>Technology Consultant Intern</h2>
      <h3>Accenture</h3>
      <p>(Mar 2021 - Jun 2021)</p>
      <ul style={{paddingLeft: "2em"}}>
        <li>Proposed cost-saving strategies by replacing costly Azure API calls with OpenCV services - reduced cost by around 10%, and created demos of MVP solutions for client’s digital transformation.</li>
        <li>Scrapped warehouse-related information of over 100 companies using Python, organized the results in excel sheets, and proposed and pitched IoT & digital twin solutions to 3+ clients</li>
        <li>Developed a web-based customer data platform prototype using SQL, JavaScript, Node JS, Express, and connected to Azure Cosmo DB.</li>
        <li>Analyzed unstructured data to draft industry reports on elevating AI solutions to promote sustainability in Chinese and global market separately and presented the reports to 10+ stakeholders</li>
        <li>Outlined product vision and actionable strategy for next generation remote working software in Avanade Innovation Contest and pitched the solution to 50+ employees</li>
      </ul>
    </div>

    <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', width:"80vw", marginBottom:"5vh"}}>
      <h2>Software Engineer & Researcher</h2>
      <h3>UNC Dr.Ryoo's Education Technology Lab</h3>
      <p>(Aug 2019 - Sep 2021)</p>
      <ul style={{paddingLeft: "2em"}}>
        <li>Led the web design team to build a lab <a href="http://ryoo-dept-soe.cloudapps.unc.edu/nsf/">website</a> from scratch using JavaScript, HTML & CSS to communicate lab outputs</li>
        <li>Conducted several independent research projects using video data from the lab to conduct qualitative analysis and semantic network analysis with R and KBDeX, and used Tableau and Gephi to visualize figures</li>
        <li>Published and presented research findings at EARLI 2021</li>
      </ul>
    </div>

    <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', width:"80vw", marginBottom:"5vh"}}>
      <h2>Product Management Club - Member</h2>
      <p>(Aug 2021 - Sep 2022)</p>
      <ul style={{paddingLeft: "2em"}}>
          <li>Collaborated with three students to design a new product prototype for a startup company using Figma.</li>
        <li>Designed and disseminate surveys across campus to better understand the need of target users.</li>
      </ul>
    </div>

    <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', width:"80vw", marginBottom:"5vh"}}>
      <h2>CS+Social Good Club - Software Engineer</h2>
      <p>(Jan 2020 - May 2020)</p>
      <ul style={{paddingLeft: "2em"}}>
          <li>Collaborated with other members to develop a warehouse management system with JavaScript, HTML & CSS.</li>
      </ul>
    </div>

    <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', width:"80vw", marginBottom:"5vh"}}>
      <h2>Appointment Peer Tutor</h2>
      <h3>Part-time job at UNC Learning Center</h3>
      <p>(Aug 2020 - Dec 2020)</p>
      <ul style={{paddingLeft: "2em"}}>
          <li>One-to-One tutoring service to UNC undergraduate students on computer science, math, sociology, and chinese courses.</li>
          <li>Work collaborately with students to resolve difficulties in practice problems and destructure complex theories and concepts.</li>
          <li>Thoroughly communicate with students to understand their learning status and designed individualized study plans and learning strategies.</li>
      </ul>
    </div>

    <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', width:"80vw", marginBottom:"5vh"}}>
      <h2>Event Service Operation Assistant</h2>
      <h3>Part-time job at UNC Carolina Union</h3>
      <p>(Sep 2019 - Feb 2020)</p>
      <ul style={{paddingLeft: "2em"}}>
          <li>Communicated with customers to understand demands, provided effective feedback and solved problems efficiently.</li>
          <li>Corporated with employees from other departments on site layout designs and staff arrangement of activities with over 200 people.</li>
      </ul>
    </div>
 
   </div>
 )
}

const ThirdSection = () =>{
 return (
  <div className='thirdSection fontBody middle-center'>
    <h2 style={{marginBottom: '3vh', marginTop:'3vh', color: 'white'}}>My Research</h2>

    <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', width:"80vw", marginBottom:"5vh"}}>
      <h3>Analysis of How can Automated Feedback Engage Students in Developing and
Explaining Models</h3>
      <p>The project aimed to analyze how automated feedback can help students in modeling activities;</p>
      <a href='#' target='_blank'>Explore More</a>
    </div>
  </div>
  
 )
}

export default Experience;